module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vCardNameForGroup":"{firstContactName} and {restOfContactsLength} other contact(s)"},"es":{"vCardNameForGroup":"{firstContactName} and {restOfContactsLength} other contact(s)"}}')
  delete Component.options._Ctor
}
